<template>
<div class="flex flex-col p-3 pt-6 sm:p-6">
    <Khead />
    
    <div class="flex justify-center">
        <div class="sm:mb-32 mb-64 bg-white mt-8 sm:w-frame rounded ">
            <div class="sm:p-10 px-3 py-10" v-if="!pleaseWaitStep && !findReloadStep">
                <div class="sm:text-2xl text-base sm:font-semibold flex flex-row justify-center items-center">
                    <span class="mr-4"><Iconcompt2/></span> 
                    <span class=" leading-6" style="color:#222F5A">{{ $t("counterRecharge.title") }}</span>
                </div> 
                <KMeterNumberEntry v-if="!paymentStep"/>
                <KMeterPayment v-if="paymentStep"/>
            </div>
            <KPleaseWait v-if="pleaseWaitStep"/>
            <ManageFindReload v-if="findReloadStep" />
        </div>
    </div>
</div>
</template>

<script>
import Iconcompt2 from '../../assets/svg/compt2.svg?inline';
import KMeterNumberEntry from '../../components/purchasesComponents/KMeterNumberEntry'
import KMeterPayment from '../../components/purchasesComponents/KMeterPayment'
import KPleaseWait from '../../components/purchasesComponents/KPleaseWait'
import Khead from '@/components/partials/Khead'
import ManageFindReload from '../../components/findReloadComponents/ManageFindReload.vue';

export default {

    data() {
        return {
            
            signMenu: false,
        }
    },
    
    components:{
        Iconcompt2,
        KMeterNumberEntry,
        KMeterPayment,
        KPleaseWait,
        Khead,
        ManageFindReload
    },
    
    computed: {
 
        paymentStep(){
            return this.$store.getters.getPaymentStep;
        },
        pleaseWaitStep(){
            return this.$store.getters.getPleaseWaitStep;
        },

        findReloadStep() {
            return this.$store.getters.getFindReloadStep;
        }
    },
    mounted() {
        this.$store.commit('mutPaymentStep', false)
        this.$store.commit('mutPleaseWaitStep', false)
        this.$store.commit('mutFindReloadStep', false)
    },
}
</script>

<style scoped>

</style>